// eslint-disable-next-line no-unused-vars
import minusSVG from "./assets/minus.svg";
// eslint-disable-next-line no-unused-vars
import checkmarkSVG from "./assets/checkmark.svg";

export default function basketFixedController(
    activities, // resolved
    locations, // resolved
    $scope,
    Search,
    Users,
    Resources,
    moment,
    $q,
    Basket,
    BasketFixedUrl,
    ActivityFactory,
    LocationFactory,
    BasketFixedToCheckout,
    loginModalFactory,
    WeekOptionsModel,
    Auth,
    $location,
    Bookings
) {
    let resource = null;
    let pResource = null;
    let search = ($scope.search = null);
    let bookingId = null;
    $scope.allowBooking = false;
    $scope.searchCompleted = false;

    Users.getAuthenticatedUser().then(
        (user) => {
            init(user);
        },
        () => {
            login();
        }
    );

    $scope.fnSearch = (params) => {
        // Will force route to rerender (used by weeks dropdown)
        BasketFixedUrl.setRoute(
            search.locationId,
            search.start,
            params.weeks,
            search.activityId,
            search.resourceId,
            search.isFixed,
            search.startTime,
            search.endTime
        );
    };

    $scope.checkout = (periods) => {
        Users.getAuthenticatedUser().then(
            (user) => {
                createBooking(periods, user, search, bookingId);
            },
            () => {
                /*
                 * Unauthorized
                 */
                login();
            }
        );
    };

    const findNextOccuranceOfFixedBpFromToday = (start) => {
        const dayINeed = moment(start).isoWeekday();
        const today = moment().isoWeekday();

        if (today <= dayINeed) {
            return moment().isoWeekday(dayINeed);
        } else {
            // otherwise, give me *next week's* instance of that same day
            return moment().add(1, "weeks").isoWeekday(dayINeed);
        }
    };

    const init = (user) => {
        BasketFixedUrl.init().then((res) => {
            search = res;

            if (moment(search.start).add(1, "days") < moment()) {
                const newStartDate = findNextOccuranceOfFixedBpFromToday(
                    search.start
                );
                search.start = moment(newStartDate).format("YYYY-MM-DD");
            }

            Resources.getAll().then(
                (resources) => {
                    resource = Resources.lookupResource(
                        search.resourceId,
                        resources
                    );

                    pResource = Resources.lookupResource(
                        resource.parentId,
                        resources
                    );

                    // Search crit must be between 4 and 13 weeks
                    search.weeks = conditionalWeeks(parseInt(search.weeks));

                    const activityLegacy = ActivityFactory.getById(
                        search.activityId,
                        activities
                    );

                    const locationLegacy = LocationFactory.getById(
                        search.locationId,
                        locations
                    );

                    $scope.activity = activityLegacy;
                    $scope.location = locationLegacy;

                    Basket.setBookingActivity(activityLegacy);
                    Basket.setBookingLocation(locationLegacy);

                    checkAvailability(search, resource, pResource).then(
                        (bps) => {
                            if (!bps.length) {
                                $scope.searchCompleted = true;
                                return;
                            }

                            // Get last fixed booking
                            const lastFixedBookedPeriod = bps.findLast(
                                (x) =>
                                    x.isAvailable == false &&
                                    x.bookingTypeId == 11
                            );

                            // Check if last booking is a fixedBooking
                            if (lastFixedBookedPeriod) {
                                // Check if the booking is yours - and append periods to the existing fixed booking (also checked in API)
                                Bookings.get(
                                    lastFixedBookedPeriod.bookingId
                                ).then((booking) => {
                                    if (user.id == booking.userId) {
                                        bookingId = booking.id;
                                    }
                                });
                            }

                            // Allow periods to be booked if all periods are open
                            // -
                            $scope.allowBooking = bps.every((x) => x.isOpen);

                            $scope.bps = bps;
                            $scope.search = search;
                            $scope.searchCompleted = true;
                        }
                    );
                },
                () => {}
            );
        });
    };

    const login = () => {
        loginModalFactory.modal().then((res) => {
            if (res == "login-user") {
                // sign in user
                Auth.login();
            }
        });
    };

    const createBooking = (periods, user, search, bookingId) => {
        const availablePeriods = periods.filter((period) => {
            return period.isAvailable;
        });

        BasketFixedToCheckout.checkout(
            user,
            search.activityId,
            availablePeriods,
            bookingId,
            search.isFixed
        ).then(
            () => {
                $location
                    .path("/checkout/bookingoptions")
                    .search({ fixed: "fixed" });
            },
            (err) => {
                $scope.allowBooking = false;
                return $q.reject(err);
            }
        );
    };

    const checkAvailability = (search, resource, pResource) => {
        return Search.checkAvailability(
            search.start,
            search.weeks,
            search.activityId,
            search.resourceId,
            search.isFixed,
            search.startTime,
            search.endTime
        ).then((res) => {
            return res.map(
                (period) => {
                    period._resource = resource;
                    period._pResource = pResource;

                    if (period._resource.maxBookingDays == 999) {
                        // rewrite db 999 logic to null to make the check easier in the future
                        period._resource.maxBookingDays = null;
                    }

                    period._startTime = moment(period.start).format("HH.mm");
                    period._endTime = moment(period.end).format("HH.mm");
                    period._dateBoxColor = period.isAvailable ? "blue" : "grey";

                    return period;
                },
                (err) => {
                    console.error(err);
                }
            );
        });
    };

    const conditionalWeeks = (weeks) => {
        const weekBarrierStart = WeekOptionsModel[0].weeks;
        const weekBarrierEnd =
            WeekOptionsModel[WeekOptionsModel.length - 1].weeks;

        switch (true) {
            case weeks < weekBarrierStart: // first (4)
                return weekBarrierStart;

            case weeks > weekBarrierEnd: //last (13)
                return weekBarrierEnd;

            default:
                return weeks;
        }
    };
}
